import { jwtDecode } from 'jwt-decode'

// =======================
// Class Money User
// =======================
var MoneyUser = function(elRoot, params) {
  var _this = this;
  params = params || {};

  if (!elRoot) return;

  _this.EL_ROOT = elRoot;
  _this.BUTTON_WIDTH = params.buttonWidth || 230;

  _this.GOOGOLE_CLIENT_ID = params.googleClientId || '1089886250762-5rufmjhrmcabbm30i3n1fjdu0g2de726.apps.googleusercontent.com';
  _this.GOOGOLE_BUTTON_ID = params.googleButtonId || 'siw-google-btn';

  _this.onLoginedCb = typeof params.onLoginedCb === 'function' ? params.onLoginedCb : function() {};
  _this.onLogoutCb = typeof params.onLogoutCb === 'function' ? params.onLogoutCb : function() {};

  _this.onSIWGoogleInitCb = typeof params.onSIWGoogleInitCb === 'function' ? params.onSIWGoogleInitCb : function() {};
  _this.onSIWGoogleCb = typeof params.onSIWGoogleCb === 'function' ? params.onSIWGoogleCb : function() {};
  _this.onSIWGoogleCompleteEfcb = typeof params.onSIWGoogleCompleteEfcb === 'function' ? params.onSIWGoogleCompleteEfcb : function() {};

  _this.requireLoginPaths = [
    '/user/',
    '/user/change-password/',
  ]

  _this.requireLogoutPaths = [
    '/user/forgot-password/',
    '/user/reset-password/',
  ]

}

MoneyUser.prototype.init = function() {
  var _this = this;
  _this.api = MoneyUserApi;

  _this.api.whoami(function(err, data) {
    _this.EL_ROOT.classList.add('inited')
    if (!err && data) {
      _this.setLogined(data.data);
    } else {
      _this.initSIWGoogle({});
      if (typeof google !== 'undefined') {
        if ( !( window.matchMedia && window.matchMedia('(max-width: 768px)').matches ) ) {
          google.accounts.id.prompt();
        }
      }
    }
  })

  window.__initsiw = function() {
    if (_this.isLogined()) return;
    _this.initSIWGoogle({});
    const elDefaultBtn = document.getElementById(_this.GOOGOLE_BUTTON_ID);
    _this.renderSIWGoogleButton(elDefaultBtn, {
      width: elDefaultBtn.clientWidth > 0 ? elDefaultBtn.clientWidth : _this.BUTTON_WIDTH,
    })
  }
  window.__initsiwTimer = setTimeout(window.__initsiw, 8000);
}

MoneyUser.prototype.checkRefresh = function(_isLogin) {
  var isLogin = !!_isLogin
  var _this = this
  var refreshPaths = _this.requireLoginPaths
  if (isLogin) {
    refreshPaths = _this.requireLogoutPaths
  }
  for (var i = 0; i < refreshPaths.length; i++) {
    if (refreshPaths[i] === document.location.pathname) {
      window.location.reload()
    }
  }
}

MoneyUser.prototype.setLogined = function(data) {
  const _this = this
  _this.EL_ROOT.classList.add('logined')
  _this.onLoginedCb(data)
  _this.checkRefresh(true)
}

MoneyUser.prototype.setLogout = function() {
  const _this = this
  _this.EL_ROOT.classList.remove('logined')
  _this.onLogoutCb()
  _this.checkRefresh()
}

// @TODO: should use a more reliable way to check if the user is logined
MoneyUser.prototype.isLogined = function() {
  return this.EL_ROOT.classList.contains('logined')
}

MoneyUser.prototype.renderSIWGoogleButton = function(el, params) {
  params = params || {};
  if (typeof google !== 'undefined') {
    google.accounts.id.renderButton(el, {
      theme: params.theme || el.dataset.theme || 'outline',
      size: params.size || el.dataset.size || 'large',
      width: params.width || el.dataset.width || 288,
      click_listener: function () {
        if (typeof params.cb === 'function') {
          params.cb()
        }
      }
    })
  }
}

// Log in with Google
MoneyUser.prototype.initSIWGoogle = function(params) {
  if (document.body.dataset.siw === 'inited') return;
  var _this = this;
  params = params || {};
  if (typeof google !== 'undefined') {
    google.accounts.id.initialize({
      client_id: _this.GOOGOLE_CLIENT_ID,
      callback: _this.onSIWGoogle.bind(_this),
      itp_support: true,
      use_fedcm_for_prompt: true,
    });
    typeof _this.onSIWGoogleInitCb === 'function' && _this.onSIWGoogleInitCb();
    document.body.dataset.siw = 'inited';
  }
}

MoneyUser.prototype.onSIWGoogle = function(response) {
  var _this = this;
  var jwtStr = response.credential;
  var rawData = jwtDecode(jwtStr);

  var email = rawData.email || '';
  var firstName = rawData.given_name || '';
  var lastName = rawData.family_name || '';

  _this.onSIWGoogleCb();

  _this.api.siwg(email, firstName, lastName, jwtStr, function(err, data) {
    if (!err && data) {
      _this.setLogined(data.data);
      _this.signInDataTracking('google', data.data.is_new_user, window.siw_google_via);
      if (data.data.is_new_user) {
        _this.signUpDataTracking(window.siw_google_via === 'sign-up-wall');
      }
    }
    _this.onSIWGoogleCompleteEfcb(err, data);
  });
}
MoneyUser.prototype.signInDataTracking = function(method, is_new_user = false, source = null) {
  window.dispatchEvent(new CustomEvent('signin_changed'));
  if (window.dataLayer) {
    __refreshUid();
    var layer = {
      event: is_new_user ? 'sign_up' : 'log_in',
      method: method,
    }
    if (source) {
      layer.sign_up_source = source;
    }
    window.dataLayer.push(layer);
  }
}
MoneyUser.prototype.signUpDataTracking = function(isSignUpWall = false) {
  window.dispatchEvent(new CustomEvent('signin_changed'));
  if (window.dataLayer) {
    __refreshUid();
    var pathname = window.location.pathname;
    var lang = (pathname.startsWith('/es/') || pathname === '/es') ? 'es' : 'en';
    if (isSignUpWall) {
      window.dataLayer.push({ event: 'subscribe', form_type: 'money_user_signup_wall', lang: lang });
    } else {
      window.dataLayer.push({ event: 'subscribe', form_type: 'money_user_signup', lang: lang });
    }
  }
}
MoneyUser.prototype.signUpActiveDataTracking = function (isSignUpWall = false) {
  if (window.dataLayer) {
    __refreshUid();
    var pathname = window.location.pathname;
    var lang = (pathname.startsWith('/es/') || pathname === '/es') ? 'es' : 'en';
    if (isSignUpWall) {
      window.dataLayer.push({ event: 'sign_up_email_activation', sign_up_email_activation_source: 'sign-up-wall' });
    } else {
      window.dataLayer.push({ event: 'sign_up_email_activation' });
    }
  }
}

// =======================
// Class Money User Api
// =======================
window.MoneyUserApi = {}

MoneyUserApi.apiRoot = '/user/api/'

MoneyUserApi.query = function(path, data, _efcb) {
  var _this = this;
  var efcb = typeof _efcb === 'function' ? _efcb : function() {};
  var xhr = new XMLHttpRequest();
  xhr.open('POST', _this.apiRoot + path + (/[^w]draft=/i.test(window.location.search) ? '?draft=true' : ''), true);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.onload = function() {
    if (xhr.status === 200) {
      try {
        var jsonResult = JSON.parse(xhr.responseText);
        if (jsonResult.status === 'success') {
          efcb(false, jsonResult);
        } else {
          efcb(jsonResult.error ? new Error(jsonResult.error) : new Error('Server error.') || true);
        }
      } catch (e) {
        efcb(new Error('Failed to parse json.'));
      }
    } else {
      efcb(new Error('Status error (' + xhr.status + ').'));
    }
  };
  xhr.onerror = function(err) {
    efcb(new Error('Network error.'));
  }
  xhr.send(JSON.stringify(data));
}


MoneyUserApi.whoami = function(_efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {}
  this.query('whoami', {}, efcb)
}

MoneyUserApi.checkEmailExists = function(email, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {}
  this.query('signin_state', { email: email }, efcb)
}

MoneyUserApi.withReferer = function(sendJson) {
  const location = window.location.toString()
  const urlObj = new URL(location)
  urlObj.hash = ""
  const urlWithoutHash = urlObj.href
  return Object.assign(sendJson, { referer: urlWithoutHash })
}

MoneyUserApi.signUp = function(sendJson, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {}
  this.query('signup', sendJson, efcb)
}

MoneyUserApi.signUpActive = function(sendJson, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {}
  this.query('signup_active', sendJson, efcb)
}

MoneyUserApi.signIn = function(sendData, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {}
  this.query('signin', sendData, efcb)
}

MoneyUserApi.signInState = function(sendData, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {}
  this.query('signin_state', sendData, efcb)
}

MoneyUserApi.siwg = function(email, firstName, lastName, rawToken, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {}
  this.query('signin_with_google', this.withReferer({
    email: email,
    firstName: firstName,
    lastName: lastName,
    rawToken: rawToken,
  }), efcb)
}

MoneyUserApi.signOut = function(_efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {};
  this.query('signout', {}, efcb)
}

MoneyUserApi.edit = function(data, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {};
  this.query('edit', data, efcb)
}


MoneyUserApi.changePassword = function(oldPassword, newPassword, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {};
  this.query('change_password', {
    oldPassword: oldPassword,
    newPassword: newPassword,
  }, efcb)
}

MoneyUserApi.forgetPassword = function(sendData, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {};
  this.query('forget_password', sendData, efcb)
}

MoneyUserApi.resetPassword = function(password, token, _efcb) {
  var efcb = typeof _efcb === 'function' ? _efcb : function() {};
  this.query('reset_password', {
    password: password,
    token: token,
  }, efcb)
}


// =======================
// Class Money User Toast
// =======================
var MoneyUserToast = function(elRoot, contentSelector) {
  var _this = this
  _this.elRoot = elRoot
  _this.contentSelector = contentSelector || '.toast-message'
  _this.elContent = elRoot.querySelector(_this.contentSelector)
  _this.ready = _this.elRoot && _this.elContent
  _this.timeoutHandler
}

MoneyUserToast.prototype.show = function(msg, infoType, _fadeInSec) {
  var _this = this
  if (!_this.ready) return
  var fadeInSec = _fadeInSec || 2;
  if (msg) {
    _this.hide(function() {
      _this.elRoot.classList.add('show')
      _this.elContent.innerText = msg
      _this.elContent.dataset.infoType = infoType || ''
      if (fadeInSec) {
        clearTimeout(_this.timeoutHandler)
        _this.timeoutHandler = window.setTimeout(_this.hide.bind(_this), fadeInSec * 1000)
      }
    })
  }
}

MoneyUserToast.prototype.hide = function(_cb) {
  var _this = this
  if (!_this.ready) return
  var cb = typeof _cb === 'function' ? _cb : function() {}
  if (_this.elRoot.classList.contains('show')) {
    _this.elRoot.classList.remove('show')
    window.setTimeout(function() {
      cb()
    }, 350)
  } else {
    cb()
  }
}

function __refreshUid() {
  if (!window.dataLayer) {
    console.log('refreshUid retry');
    setTimeout(__refreshUid, 500);
    return;
  }
  try {
    var mub = document.cookie
      .split(';')
      .map(x => x.trim())
      .reduce((prev, curr) => {
        const pair = curr.split('=');
        prev[pair[0]] = pair[1];
        return prev;
      }, {})['__mub'];
    var uid = JSON.parse(decodeURIComponent(mub)).uid;
    if (uid) {
      window.dataLayer.push({
        'user_id': uid,
      });
    }
  } catch (e) {}
}


// =======================
// UI Init
// =======================
window.addEventListener('load', function () {
  __refreshUid();
  var elRoot = document.querySelector('.money-user-box');
  if (!elRoot) return;

  var elSwThirdParty = elRoot.querySelector('.sw-third-party')

  var btnToggleSignin = elRoot.querySelector('.btn-toggle-signin')
  var btnToggleSignup = elRoot.querySelector('.btn-create-account')

  var elSigninRecaptchaCheckboxCon = elRoot.querySelector('.signin-recaptcha-checkbox-con')
  var elSignupRecaptchaCheckboxCon = elRoot.querySelector('.signup-recaptcha-checkbox-con')

  var btnSignout = elRoot.querySelector('.btn-signout')

  var elsPopups = [].slice.call(elRoot.querySelectorAll('.popups-con'))

  var elPopupSignin = elRoot.querySelector('.popups-signin')
  var btnPopupSigninClose = elPopupSignin.querySelector('.popup-close')
  var formPopupSignin = elPopupSignin.querySelector('form')
  var elSwThirdPartyConPopupSignin = elPopupSignin.querySelector('.sw-third-party-con')

  var elPopupSignup = elRoot.querySelector('.popups-signup')
  var btnPopupSignupClose = elPopupSignup.querySelector('.popup-close')
  var formPopupSignup = elPopupSignup.querySelector('form')
  var elSwThirdPartyConPopupSignup = elPopupSignup.querySelector('.sw-third-party-con')

  var btnTogglePassword = elPopupSignup.querySelector('.toggle-password label')
  var feSignupPassword = elPopupSignup.querySelector('#fe-signup-password')
  var elPasswordErrors = elPopupSignup.querySelector('.password-errors')

  var elToastCon = elRoot.querySelector('.toasts-con')
  var elSignupSuccessCon = elRoot.querySelector('.signup-success-con')
  var btnSignupSuccessConClose = elSignupSuccessCon.querySelector('.popup-close')

  var elSubsManageLink = elRoot.querySelector('.popup-user-menu .subs-manage-link')

  var getStatus = function (elPopup) {
    var pageName = '';
    [].slice.call(elPopup.classList).map(function (clsName) {
      var pageNameM = /^page-status-(.*)/.exec(clsName)
      if (pageNameM) {
        pageName = pageNameM[1]
      }
    })
    return pageName
  }
  var getSigninStatus = function () { return getStatus(elPopupSignin) }
  var getSignupStatus = function () { return getStatus(elPopupSignup) }

  var setStatus = function (elPopup, pageName) {
    [].slice.call(elPopup.classList).map(function (clsName) {
      if (/^page-status-/.test(clsName)) {
        elPopup.classList.remove(clsName)
      }
    });
    [].slice.call(elPopup.querySelector('.pages').querySelectorAll('a,input,button')).map(function (el) {
      el.tabIndex = -1;
    });
    [].slice.call(elPopup.querySelector('.page-' + pageName).querySelectorAll('a,input,button')).map(function (el) {
      el.tabIndex = 1;
    })
    elPopup.classList.add('page-status-' + pageName)
  }
  var setSigninStatus = function (pageName) { return setStatus(elPopupSignin, pageName) }
  var setSignupStatus = function (pageName) { return setStatus(elPopupSignup, pageName) }

  var setFocusIfEmpty = function (fe) {
    window.setTimeout(function () {
      if (!fe.value) fe.focus()
    }, 350)
  }

  var clearForm = function (elForm) {
    [].slice.call(elForm.elements).map(function (el) {
      if (el.tagName === 'INPUT') {
        if (~['text', 'email', 'password', 'number',].indexOf(el.type)) {
          el.value = ''
        }
      }
    })
  }

  var setFormAjaxLoading = function (elForm, isLoading) {
    var els = [].slice.call(elForm.elements);
    if (isLoading) {
      elForm.classList.add('ajax-loading');
      els.map(function (el) {
        el.disabled = true;
      });
    } else {
      elForm.classList.remove('ajax-loading');
      els.map(function (el) {
        el.disabled = false;
      });
    }
  }

  var showPopupSignin = window.show_sign_into_money_popup = function () {
    elPopupSignin.classList.add('show')
    elSwThirdPartyConPopupSignin.appendChild(elSwThirdParty);
    var elSubmitErrors = formPopupSignin.querySelector('.submit-errors');
    elSubmitErrors.classList.remove('has-error');
    var feEmail = formPopupSignin.elements['signin-email'];
    setFocusIfEmpty(feEmail)
  }

  var showPopupSignup = function () {
    elPopupSignup.classList.add('show')
    elSwThirdPartyConPopupSignup.appendChild(elSwThirdParty);
    var elSubmitErrors = formPopupSignup.querySelector('.submit-errors');
    elSubmitErrors.classList.remove('has-error');
    var feEmail = formPopupSignup.elements['signup-email'];
    setFocusIfEmpty(feEmail)
  }

  var showSignupSuccessCon = function (data) {
    // elSignupSuccessCon.classList.add('show')
    var redirectUrl = '/subscribe/check_your_email/' + (/[^w]draft=/i.test(window.location.search) ? '?draft=true' : '');
    var pageUrl = new URL(window.location.href);
    if (pageUrl.searchParams.has('utm_campaign')) {
      if (redirectUrl.indexOf('?') === -1) {
        redirectUrl += '?';
      } else {
        redirectUrl += '&';
      }
      redirectUrl += 'campaign_config=' + encodeURIComponent(pageUrl.searchParams.get('utm_campaign'));
    }
    window.setTimeout( function(){
      window.location.href = redirectUrl;
    }, 100 );
  }

  var hidePopupSignin = function () {
    elPopupSignin.classList.remove('show')
  }

  var hidePopupSignup = function () {
    elPopupSignup.classList.remove('show')
  }

  var hideSignupSuccessCon = function () {
    elSignupSuccessCon.classList.remove('show')
  }

  var hideAllPopups = function () {
    elsPopups.map(function (el) {
      el.classList.remove('show')
    })
  }

  var setFeError = function (fe, msg) {
    if (!fe) return
    var elCon = fe.parentNode
    var elErrMsg = elCon.querySelector('.err-msg')
    if (!elErrMsg) {
      elErrMsg = document.createElement('div')
      elErrMsg.classList.add('err-msg')
      elCon.appendChild(elErrMsg);
    }
    if (typeof msg === 'undefined') {
      elCon.classList.remove('has-error')
    } else {
      elErrMsg.innerText = msg
      elCon.classList.add('has-error')
    }
  }

  var isEmail = function (str) {
    return /^[\w.%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(str || '') ? str.toLowerCase() : null;
  }

  var validateEmail = function (fe) {
    if (fe) {
      if (!fe.dataset.vEmailInited) {
        fe.addEventListener('keyup', function () {
          var lastVal = fe.dataset.lastVal || undefined
          if (lastVal !== fe.value) {
            fe.dataset.lastVal = val
            validateEmail(fe)
          }
        })
        fe.dataset.vEmailInited = 1;
      }
      var val = fe.value
      if (val) {
        if (isEmail(val)) {
          setFeError(fe)
          return true
        } else {
          setFeError(fe, 'Enter a valid email address')
        }
      } else {
        setFeError(fe, 'Email is required.')
      }
    }
  }

  var validateRequired = function (fe) {
    if (fe) {
      if (!fe.dataset.vEmailInited) {
        fe.addEventListener('keyup', function () {
          var lastVal = fe.dataset.lastVal || undefined
          if (lastVal !== fe.value) {
            fe.dataset.lastVal = val
            validateRequired(fe)
          }
        })
        fe.dataset.vEmailInited = 1;
      }
      var val = fe.value
      var ph = fe.placeholder
      if (val) {
        setFeError(fe)
        return true
      } else {
        setFeError(fe, 'Enter ' + ph)
      }
    }
  }

  var setPasswordErrors = function (flags) {
    var elCon = elPasswordErrors.parentNode
    if (flags instanceof Object) {
      elPasswordErrors.querySelector('.uppercase').dataset.status = flags.uppercase ? 'right' : 'wrong'
      elPasswordErrors.querySelector('.number').dataset.status = flags.number ? 'right' : 'wrong'
      elPasswordErrors.querySelector('.eight-chars').dataset.status = flags.eightChars ? 'right' : 'wrong'
      elCon.classList.add('has-error')
    } else {
      if (flags === true) {
        [].slice.call(elPasswordErrors.querySelectorAll('li')).map(function (el) { el.dataset.status = "right" })
        elCon.classList.remove('has-error')
      } else if (flags === false) {
        [].slice.call(elPasswordErrors.querySelectorAll('li')).map(function (el) { el.dataset.status = "wrong" })
        elCon.classList.add('has-error')
      } else {
        [].slice.call(elPasswordErrors.querySelectorAll('li')).map(function (el) { el.dataset.status = "" })
        elCon.classList.remove('has-error')
      }
    }
  }

  var initValidatePassword = function (fe) {
    if (!fe.dataset.vEmailInited) {
      fe.addEventListener('keyup', function () {
        var lastVal = fe.dataset.lastVal || undefined
        if (lastVal !== fe.value) {
          fe.dataset.lastVal = fe.value
          validatePassword(fe)
        }
      })
      fe.dataset.vEmailInited = 1;
    }
  }

  var validatePassword = function (fe) {
    if (fe) {
      var val = fe.value
      var ph = fe.placeholder
      if (val) {
        var testUppercase = /[A-Z]+/.test(val)
        var testNumber = /[0-9]+/.test(val)
        var testEightChars = val.length >= 8
        var flags = {}
        if (testUppercase) {
          flags.uppercase = 1
        }
        if (testNumber) {
          flags.number = 1
        }
        if (testEightChars) {
          flags.eightChars = 1
        }
        if (testUppercase && testNumber && testEightChars) {
          setPasswordErrors(true)
          return true
        } else {
          setPasswordErrors(flags)
        }
      } else {
        setPasswordErrors(false)
      }
    }
  }

  var checkLabelPlaceholder = function (elFe) {
    if (elFe.value) {
      elFe.classList.add('present')
    } else {
      elFe.classList.remove('present')
    }
  }

  var toast = new MoneyUserToast(elToastCon)

  window._toast = toast;

  var user = new MoneyUser(elRoot, {
    buttonWidth: 288,
    onLoginedCb: function (data) {
      elSubsManageLink.href = 'https://vault.money.com/subscriptions/new?email=' + encodeURIComponent(data.email)
      if (data.pm && !document.querySelector('.mu-dd-ad') ) {
        var elLiAdmin = document.createElement('li')
        elLiAdmin.innerHTML = '<a href="/admin/" class="mu-dd-ad" >Admin Dashboard</a>'
        var elLiSub = elSubsManageLink.parentNode
        var elUl = elLiSub.parentNode
        if (elLiSub.nextElementSibling) {
          elUl.insertBefore(elLiAdmin, elLiSub.nextElementSibling)
        } else {
          elUl.appendChild(elLiAdmin);
        }
      }
    },
    onLogoutCb: function (data) { },
    onSIWGoogleInitCb: function () {
      elRoot.classList.add('siwg-inited')
    },
    onSIWGoogleCb: function () {
      hidePopupSignin()
      hidePopupSignup()
      if (window.__pwfn && typeof window.__pwfn.close === 'function') {
        window.__pwfn.close()
      }
      toast.show('Signing in with Google', 'loading', 120)
    },
    onSIWGoogleCompleteEfcb: function (err, data) {
      if (err) {
        toast.show('Log in failed. Try again.')
      } else {
        toast.show('Log in successful. Welcome back!')
      }
    },
  });
  user.init();
  window._user = user;

  btnTogglePassword.addEventListener('click', function () {
    if (feSignupPassword.type === 'text') {
      feSignupPassword.type = 'password'
    } else {
      feSignupPassword.type = 'text'
    }
  })

  var feLabelPhs = [].slice.call(elRoot.querySelectorAll('.fe-label-ph'))
  feLabelPhs.map(function (elFe) {
    elFe.addEventListener('change', function () {
      checkLabelPlaceholder(elFe);
    });
    checkLabelPlaceholder(elFe);
  });

  btnToggleSignin.addEventListener('click', function () {
    try {
      if (document.body.dataset.recaptcha !== 'inited' &&
        typeof window.loadRecaptcha === 'function'
      ) {
        window.loadRecaptcha()
        clearTimeout(window.delayRecaptchaTimer)
      }

      if (typeof window.__initsiw === 'function') {
        window.__initsiw();
        clearTimeout(window.__initsiwTimer);
      }

    } catch (err) {
      console.error(err)
    }

    if (elPopupSignin.classList.contains('show')) {
      hidePopupSignin()
    } else {
      if (elPopupSignup.classList.contains('show')) {
        hideAllPopups()
        window.setTimeout(showPopupSignin, 300)
      } else {
        showPopupSignin()
      }
    }
  })

  btnToggleSignup.addEventListener('click', function () {
    if (elPopupSignup.classList.contains('show')) {
      hidePopupSignup()
    } else {
      if (elPopupSignin.classList.contains('show')) {
        hideAllPopups()
        window.setTimeout(showPopupSignup, 300)
      } else {
        showPopupSignup()
      }
    }
  })

  btnPopupSigninClose.addEventListener('click', function () {
    hidePopupSignin()
  })
  btnPopupSignupClose.addEventListener('click', function () {
    hidePopupSignup()
  })
  btnSignupSuccessConClose.addEventListener('click', function () {
    hideSignupSuccessCon()
  })

  formPopupSignin.addEventListener('submit', function (evt) {
    evt.preventDefault()
    evt.stopPropagation()
    var pageStatus = getSigninStatus()
    var feEmail = formPopupSignin.elements['signin-email'];
    var fePassword = formPopupSignin.elements['signin-password'];
    var elSubmitErrors = formPopupSignin.querySelector('.submit-errors');
    switch (pageStatus) {
      case 'start':
        var vEmail = validateEmail(feEmail)
        var vPassword = validateRequired(fePassword)
        if (vEmail && vPassword) {
          var email = feEmail.value;
          var password = fePassword.value;
          setFormAjaxLoading(formPopupSignin, true);
          elSubmitErrors.classList.remove('has-error');
          var sendJson = {
            email: email,
            password: password,
          }
          user.api.signIn(sendJson, function (err, data) {
            if (err) {
              if ('reCaptchaV3Failed' === err.message) {
                reCaptchaClient.renderCheckbox(elSigninRecaptchaCheckboxCon);
              } else {
                elSubmitErrors.innerText = err.message || 'Error occurred.'
                elSubmitErrors.classList.add('has-error');
              }
            } else {
              user.setLogined(data.data)
              user.signInDataTracking('email', false);
              hidePopupSignin()
              toast.show('Log in successful. Welcome back!')
              reCaptchaClient.clear(elSigninRecaptchaCheckboxCon)
              clearForm(formPopupSignin)
            }
            setFormAjaxLoading(formPopupSignin)
          });
        }
        break;
    }
  })

  formPopupSignup.addEventListener('submit', function (evt) {
    evt.preventDefault()
    evt.stopPropagation()
    var pageStatus = getSignupStatus()
    var feEmail = formPopupSignup.elements['signup-email'];
    var feFirstName = formPopupSignup.elements['signup-first-name']
    var felLastName = formPopupSignup.elements['signup-last-name']
    var fePassword = formPopupSignup.elements['signup-password'];
    var elSubmitErrors = formPopupSignup.querySelector('.submit-errors');
    switch (pageStatus) {
      case 'start':
        if (validateEmail(feEmail)) {
          setFormAjaxLoading(formPopupSignup, true);
          user.api.checkEmailExists(feEmail.value, function (err, result) {
            if (!err) {
              if (result.data && result.data.state === "not_exists") {
                setSignupStatus('name')
                setFocusIfEmpty(feFirstName)
              } else {
                setFeError(feEmail, 'This email is already registered. Try another or Sign In.')
              }
            } else {
              elSubmitErrors.innerText = err.message
              elSubmitErrors.classList.add('has-error')
            }
            setFormAjaxLoading(formPopupSignup)
          })
        }
        break;
      case 'name':
        var vFirstname = validateRequired(feFirstName)
        var vLastName = validateRequired(felLastName)
        if (vFirstname && vLastName) {
          setSignupStatus('password')
          setFocusIfEmpty(fePassword)
          elSubmitErrors.classList.remove('has-error');
          if (elSignupRecaptchaCheckboxCon.dataset.widgetId) {
            reCaptchaClient.reset(elSignupRecaptchaCheckboxCon);
          } else {
            reCaptchaClient.renderCheckbox(elSignupRecaptchaCheckboxCon);
          }
        }
        break;
      case 'password':
        if (validatePassword(fePassword)) {
          var sendJson = {
            email: feEmail.value,
            password: fePassword.value,
            first_name: feFirstName.value,
            last_name: felLastName.value,
            signup_source: '',
          }
          setFormAjaxLoading(formPopupSignup, true);
          elSubmitErrors.classList.remove('has-error')

          reCaptchaClient.verifyV2Only(elSignupRecaptchaCheckboxCon, 'topnav_signup', function (err, appendToken) {
            if (!err) {
              sendJson = appendToken(sendJson)
              sendJson = user.api.withReferer(sendJson)
              user.api.signUpActive(sendJson, function (err, data) {
                if (err) {
                  elSubmitErrors.innerText = err.message || 'Error occurred.'
                  elSubmitErrors.classList.add('has-error');
                } else {
                  user.signUpActiveDataTracking()
                  hidePopupSignup()
                  showSignupSuccessCon(data.data)
                  clearForm(formPopupSignup)
                  setSignupStatus('start')
                }
                setFormAjaxLoading(formPopupSignup)
              });
            } else {
              elSubmitErrors.innerText = err.message
              elSubmitErrors.classList.add('has-error')
              setFormAjaxLoading(formPopupSignup)
            }
          });
        }
        break;
    }
  })

  formPopupSignup.addEventListener('click', function (evt) {
    if (evt.target.classList.contains('btn-go-back')) {
      var pageStatus = getSignupStatus()
      switch (pageStatus) {
        case 'name':
          setSignupStatus('start')
          break;
        case 'password':
          setSignupStatus('name')
          break;
      }
    }
  })

  btnSignout.addEventListener('click', function (evt) {
    evt.stopPropagation()
    evt.preventDefault()
    // toast.show('Login out.', 'loading', 120)
    user.api.signOut(function (err, data) {
      if (err) {
        toast.show(err.message || 'Login out fail.', 'error')
      } else {
        toast.show('Logged out successfully')
        user.setLogout()
        window.dispatchEvent(new CustomEvent('signin_changed'));
      }
    });
  })

  setSigninStatus('start')
  setSignupStatus('start')

  initValidatePassword(feSignupPassword)

  const evt = new CustomEvent('mujs:inited', {})
  document.body.dispatchEvent(evt)
  document.body.dataset.mujs = 'inited';

});
